import React, { useEffect } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { getStatAtlas } from '../../../http/manager';
import * as echarts from 'echarts';

const GraphLibrary: React.FC = () => { 
    useEffect(()=> {
        getData();
        return;
    }, [])
    const getData = ()=> {
        getStatAtlas({}).then((res:any)=> {
            let xData = [];
            let yData = [];
            if(res.data.length > 0) {
                for(let i=0, len=res.data.length; i<len; i++) {
                    xData.push(res.data[i].name);
                    yData.push(res.data[i].value);
                }
            }
            let myChart = echarts.init(document.getElementById('rechartGraph'));
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                      type: 'shadow'
                    }
                },
                grid: {
                    top: '10%',
                    left: '6%',
                    right: '6%',
                    bottom: '12%'
                },
                xAxis: {
                    type: 'category',
                    data: xData
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: yData,
                        type: 'bar',
                        barWidth: '28px',
                        itemStyle: {        //上方显示数值
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: 'rgba(0,0,0,.65)',
                                        fontSize: 10
                                    }
                                },
                                color: function (colors:any) {
                                    var colorList = [
                                        '#7586A3',
                                        '#73DEB3',
                                        '#ED7E66',
                                        '#73A0FA'
                                    ];
                                    return colorList[colors.dataIndex];
                                }
                            }
                        }
                    }
                ]
            })
        })
    }
    return (
        <GraphContainer>
            <div id='rechartGraph' style={{ width: '100%', height: '100%' }}></div>
        </GraphContainer>
    )
}

export default observer(GraphLibrary);

const GraphContainer = styled.div`
    & {
        width: 100%;
        height: 100%;
    }
`